var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { ref: "navigation", staticClass: "nav", attrs: { id: "nav" } },
    _vm._l(_vm.nav, function (d1) {
      return _c(
        "div",
        {
          key: d1.sequence,
          staticClass: "nav-menu",
          on: { mouseenter: _vm.handleHover, mouseleave: _vm.handleHover },
        },
        [
          _c("input", {
            staticClass: "nav-menu__trigger a11y",
            attrs: {
              type: "radio",
              id: "d1-" + d1.sequence,
              name: "nav-menu__trigger",
            },
            domProps: { value: "d1-" + d1.sequence },
            on: { click: _vm.handleActiveNav },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "nav-menu__label",
              attrs: { for: "d1-" + d1.sequence },
            },
            [
              _c("span", { staticClass: "a11y" }, [
                _vm._v(_vm._s(d1.title) + " 메뉴 열기"),
              ]),
              _vm._v(" "),
              _c("icon-arrow", { staticClass: "icon icon-arrow--down" }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "nav-menu__d1",
              class: {
                "is-current--menu": _vm.handleCurrentMenu(
                  _vm.getUrlPath(d1.titleLink)
                ),
              },
              attrs: { href: _vm.getUrlPath(d1.titleLink), target: d1.target },
            },
            [_vm._v("\n      " + _vm._s(d1.title) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nav-menu__block" }, [
            _c(
              "a",
              {
                staticClass: "nav-menu__more",
                attrs: {
                  href: _vm.getUrlPath(d1.subtitleLink),
                  role: d1.subtitleLink ? "heading link" : "heading",
                },
              },
              [
                _c("mark", [
                  _vm._v(_vm._s(_vm._f("extractSubtitle")(d1.subtitle, 0))),
                ]),
                _vm._v(" "),
                _c("pre", [
                  _vm._v(_vm._s(_vm._f("extractSubtitle")(d1.subtitle, 1))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "nav-menu__list" },
              _vm._l(d1.children, function (d2, i) {
                return _c("li", { key: i }, [
                  _c(
                    "a",
                    {
                      ref: "menuD2",
                      refInFor: true,
                      staticClass: "nav-menu__d2",
                      class: {
                        "is-current--menu": _vm.handleCurrentMenu(
                          _vm.getUrlPath(d2.titleLink)
                        ),
                      },
                      attrs: {
                        href: _vm.getUrlPath(d2.titleLink),
                        target: d2.target,
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(d2.title) + "\n          "
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            d1.banner
              ? _c(
                  "a",
                  {
                    staticClass: "nav-banner",
                    class: "nav-banner--" + d1.sequence,
                    attrs: {
                      href: d1.banner.targetUrl,
                      target: d1.banner.targetWindow && "_blank",
                    },
                  },
                  [
                    _c("strong", { staticClass: "nav-banner__strong" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(d1.banner.subtitle)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "nav-banner__title",
                          style: { color: d1.banner.assets.DESKTOP[0].bgTheme },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(d1.banner.title) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("picture", { staticClass: "nav-banner__pic" }, [
                      _c("source", {
                        attrs: {
                          media: "(max-width: 959px)",
                          srcset:
                            d1.banner.assets.DESKTOP[0].url ||
                            d1.banner.assets.MOBILE[0].url,
                        },
                      }),
                      _vm._v(" "),
                      _c("source", {
                        attrs: {
                          media: "(min-width: 960px)",
                          srcset: d1.banner.assets.DESKTOP[0].url,
                        },
                      }),
                      _vm._v(" "),
                      _c("img", {
                        attrs: {
                          src: d1.banner.assets.DESKTOP[0].url,
                          alt: "",
                        },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }